import React from 'react';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import About from '../components/sections/About';
import VisionMission from '../components/sections/VisionMission';
import CoreValues from '../components/sections/CoreValues';
import Statistics from '../components/sections/Statistics';
import Testimonials from '../components/sections/Testimonials';
import CTA from '../components/sections/CTA';

interface HomeProps {
  counters: {
    projects: number;
    satisfaction: number;
    years: number;
    support: number;
  };
}

const Home: React.FC<HomeProps> = ({ counters }) => {
  return (
    <main>
      <Hero />
      <Services />
      <About />
      <VisionMission />
      <CoreValues />
      <Statistics counters={counters} />
      <Testimonials />
      <CTA />
    </main>
  );
};

export default Home;
